import { render, staticRenderFns } from "./edit-message.vue?vue&type=template&id=07cb6a1b"
import script from "./edit-message.vue?vue&type=script&lang=ts"
export * from "./edit-message.vue?vue&type=script&lang=ts"
import style0 from "./edit-message.vue?vue&type=style&index=0&id=07cb6a1b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports